var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"facebook-btn",on:{"click":_vm.loginToFacebook}},[_vm._v(_vm._s(_vm.btnTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }